<template>
  <div>
    <h2>{{ meeting.name }}</h2>
    <h5>
      {{
        "Date et heure de debut de la reunion: " +
        $moment(meeting.meeting_date).locale("fr").format("DD MMMM YYYY [à] HH[h]mm")
      }}
    </h5>
    <hr />
    <appMeetingResolutionsTable :meeting-id="meeting.id" :building-id="meeting.building_id" />
  </div>
</template>

<script>
import appMeetingResolutionsTable from "@/components/snippets/MeetingResolutionsTable";
import MeetingORM from "@/store/orm-axios/models/Meeting";

export default {
  components: {
    appMeetingResolutionsTable,
  },
  data() {
    return {
      meeting: null,
    };
  },
  created() {
    this.meeting = MeetingORM.find(this.$route.params.id);
  },
};
</script>
